module.exports = __webpack_public_path__ + "static/media/ios-git-branch.96df9373.svg";